import React, { useMemo } from "react";

import { useLocation } from "react-router-dom";

import { BackGround } from "./styled";

export const CustomerPortalBackGround = () => {
  const location = useLocation();

  const shouldRenderBackGround = useMemo(() => {
    return location.pathname === "/";
  }, [location]);

  if (!shouldRenderBackGround) return <></>;

  return <BackGround />;
};
